import React, { useState, useEffect } from "react";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';
import AllSaleOrder from "./AllSaleOrder";
import NewSaleForm from "./NewSaleForm";
import EditSaleForm from "./EditSaleForm";
import axios from 'axios';
import './SaleOrder.css';

const SaleOrder = () => {
    // Default tab should be 'All Sale Orders'
    const [activeTab, setActiveTab] = useState('All Sale Orders');
    const [editSaleOrderId, setEditSaleOrderId] = useState(null);
    const [showEditDrawer, setShowEditDrawer] = useState(false);
    const [drawerMounted, setDrawerMounted] = useState(false);
    const [drawerClosing, setDrawerClosing] = useState(false);
    
    // New state for Status Totals and Counts
    const [statusTotals, setStatusTotals] = useState({
        Draft: '0.00',
        Sent: '0.00',
        Expired: '0.00',
        Declined: '0.00',
        Accepted: '0.00',
        Open: '0.00',
        Revised: '0.00'
    });
    
    const [statusCounts, setStatusCounts] = useState({
        Draft: 0,
        Sent: 0,
        Expired: 0,
        Declined: 0,
        Accepted: 0,
        Open: 0,
        Revised: 0
    });
    
    const userType = localStorage.getItem("usertype");
    const userFullName = (localStorage.getItem("fname") || "") + " " + (localStorage.getItem("lname") || "");

    // Fetch status stats on mount
    useEffect(() => {
        fetchStatusStats();
    }, [activeTab]);

    useEffect(() => {
        if (showEditDrawer && !drawerClosing) {
            const id = requestAnimationFrame(() => {
                requestAnimationFrame(() => setDrawerMounted(true));
            });
            return () => cancelAnimationFrame(id);
        }
    }, [showEditDrawer, drawerClosing]);

    const fetchStatusStats = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get('https://skcapi.btcjapan.co/get_sale_orders.php', {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data.success) {
                if (res.data.status_totals) setStatusTotals(res.data.status_totals);
                if (res.data.status_counts) setStatusCounts(res.data.status_counts);
            }
        } catch (err) {
            console.error("Error fetching status stats:", err);
        }
    };

    const handleSaleOrderCreated = () => {
        setActiveTab('All Sale Orders');
        fetchStatusStats(); // Refresh stats
    };

    const openEditDrawer = (id) => {
        setEditSaleOrderId(id);
        setDrawerClosing(false);
        setDrawerMounted(false);   // start closed
        setShowEditDrawer(true);
    };

    const closeEditDrawer = () => {
        if (!showEditDrawer) return;
        setDrawerClosing(true);
        setTimeout(() => {
            setShowEditDrawer(false);
            setEditSaleOrderId(null);
            setDrawerClosing(false);
            setDrawerMounted(false);
        }, 280);   // matches .drawer-closing transition duration
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <SuperAdminSidebar />}
                {userType === "leader" && <LeaderSidebar />}
                {userType === "manager" && <ManagerSidebar />}
                {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                <AdminNavbar pageTitle="Sale Order" />

                <div className="all-content">

                    {/* ========== STATUS STATS BAR ========== */}
                    <div className="sale-order-stats-bar">
                        <div className="stat-box draft">
                            <div className="stat-amount">$ {statusTotals.Draft}</div>
                            <div className="stat-label">Draft</div>
                        </div>
                        <div className="stat-box sent">
                            <div className="stat-amount">$ {statusTotals.Sent}</div>
                            <div className="stat-label">Sent</div>
                        </div>
                        <div className="stat-box expired">
                            <div className="stat-amount">$ {statusTotals.Expired}</div>
                            <div className="stat-label">Expired</div>
                        </div>
                        <div className="stat-box declined">
                            <div className="stat-amount">$ {statusTotals.Declined}</div>
                            <div className="stat-label">Declined</div>
                        </div>
                        <div className="stat-box accepted">
                            <div className="stat-amount">$ {statusTotals.Accepted}</div>
                            <div className="stat-label">Accepted</div>
                        </div>
                    </div>
                    {/* ==================================== */}

                    <div className="sale-order-main-section">
                        <div className="sale-order-tabs-container">
                            <button 
                                className={`sale-order-tab-btn ${activeTab === 'All Sale Orders' ? 'active-tab' : ''}`}
                                onClick={() => setActiveTab('All Sale Orders')}
                            >
                                All Sale Orders
                            </button>
                            <button 
                                className={`sale-order-tab-btn ${activeTab === 'New Sale Order' ? 'active-tab' : ''}`}
                                onClick={() => setActiveTab('New Sale Order')}
                            >
                                New Sale Order
                            </button>
                        </div>

                        <div className="sale-order-content-area">
                            {activeTab === 'All Sale Orders' && <AllSaleOrder openEditDrawer={openEditDrawer} refreshTrigger={activeTab} />}
                            {activeTab === 'New Sale Order' && <NewSaleForm onSaleOrderCreated={handleSaleOrderCreated} currentUserFullName={userFullName} />}
                        </div>
                    </div>

                </div>
            </div>

            {/* ========== EDIT SIDE DRAWER ========== */}
            {showEditDrawer && (
                <>
                    <div
                        className={`sale-order-drawer ${
                            drawerClosing ? 'drawer-closing' : (drawerMounted ? 'drawer-open' : '')
                        }`}
                    >
                        <div className="sale-order-drawer-header">
                            <h3>Edit Sale Order</h3>
                            <button
                                onClick={closeEditDrawer}
                                className="sale-order-drawer-close"
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                        <EditSaleForm
                            saleOrderId={editSaleOrderId}
                            onSaleOrderUpdated={() => {
                                closeEditDrawer();
                                setActiveTab('All Sale Orders');
                                fetchStatusStats();
                            }}
                            currentUserFullName={userFullName}
                            onCancel={closeEditDrawer}
                        />
                    </div>

                    <div
                        className={`sale-order-drawer-overlay ${
                            drawerClosing ? 'overlay-closing' : (drawerMounted ? 'overlay-open' : '')
                        }`}
                        onClick={closeEditDrawer}
                    />
                </>
            )}

            {showEditDrawer && (
                <div onClick={closeEditDrawer} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 9998 }} />
            )}
        </div>
    )
}

export default SaleOrder;